import React from 'react';
import type { InputNode } from '../types';

/**
 * 必填红星包装（V1 parity：select/multi-variable/searchable-select/cascader/datepicker/textarea
 * 的 render.ts 都在 required 时外套 `.exclusion-wrapper.required-upload-group` + `.rte-text-required`
 * 红星 icon）。VariableNode/UploadNode 等已各自内联实现此结构，这里抽出共享给原先漏标的节点复用，
 * 保证所有 required 节点视觉一致。
 *
 * 用法：节点主返回包一层 —— `<RequiredMark node={node}>{原 return}</RequiredMark>`。
 * 非 required 时直接透传 children，不加任何 DOM。
 */
export const RequiredMark: React.FC<{
  node: InputNode;
  children: React.ReactNode;
}> = ({ node, children }) => {
  if (!node.required) return <>{children}</>;
  return (
    <span
      className="exclusion-wrapper required-upload-group"
      data-group={node.exclusionGroup}
    >
      <span className="rte-text-required">
        <i className="iconfont icon-bitian" style={{ fontSize: 10 }} />
      </span>
      {children}
    </span>
  );
};
RequiredMark.displayName = 'RequiredMark';
